const Colors = {
  black: "#3b3836",
  blue: "#89C7E1",
  darkblue: "#485a6c",
  green: "#99dac5",
  yellow: "#fdbd1b",
  salmon: "#f3a28c",
  red: "#ba6a67",
  purple: "#a99dc1",
  orange: "#E1A389",
  oranges: [
    "#E1A389",
    "#E8BAA7",
    "#F0D1C4",
    "#F7E8E2",
  ]
}

export const tiles = [Colors.green, Colors.yellow, Colors.salmon, Colors.red, Colors.purple]

export default Colors